import React, { Fragment, memo, useCallback, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Tour } from '@Sage/ssm-web5';

import ToursOverlay from 'containers/components/ToursOverlay';
import { LEADS_LITERALS } from 'containers/components/LeadsModal/literals';
import { COMPANIES } from 'constants/Entities';
import { getLiteral } from 'utils/getLiteral';
import { setNewToursObj } from 'utils/tours';

export const LEADS_TOUR_NAME = 'mapLeadsTour';
export const LEADS_CTA_SELECTOR = '.fm-companies-header__leads-cta';

const LeadsHeaderTour = ({ enabled }) => {
    const [targets, setTargets] = useState(null);
    const tourDisabled = useSelector(
        (state) => state.config.components?.tours?.[COMPANIES.entity]?.[LEADS_TOUR_NAME]?.disabled,
    );

    const onClose = useCallback(() => {
        setNewToursObj({ entity: COMPANIES, tourName: LEADS_TOUR_NAME });
        setTargets(null);
    }, []);

    const steps = useMemo(
        () => [
            {
                selector: LEADS_CTA_SELECTOR,
                title: getLiteral(LEADS_LITERALS.prospectFromMap),
                description: getLiteral(LEADS_LITERALS.tourDescription),
                placement: 'bottom',
                onReady: () => setTargets([LEADS_CTA_SELECTOR]),
            },
        ],
        [],
    );

    if (!enabled || tourDisabled) return null;

    return (
        <Fragment>
            <ToursOverlay targets={targets} padding={8} />
            <Tour steps={steps} onClose={onClose} delay={800} />
        </Fragment>
    );
};

export default memo(LeadsHeaderTour);
